export function flattenObject(value: any, separator = '.', parentKey = ''): Record<string, unknown> {
  if (typeof value !== 'object' || value === null) {
    return { [parentKey]: value };
  }

  let results: Record<string | number, unknown> = {};

  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      Object.assign(results, flattenObject(item, separator, `${parentKey}${separator}${index}`));
    });
  } else if (typeof value === 'object') {
    for (const key in value) {
      if (key === '$id') {
        continue;
      }

      if ((typeof key === 'string' || typeof key === 'number') && value.hasOwnProperty(key)) {
        const newKey = parentKey ? `${parentKey}${separator}${key}` : key;

        if (key in value && typeof value[key] === 'object' && value[key] !== null) {
          Object.assign(results, flattenObject(value[key], separator, newKey));
        } else {
          results[newKey] = value[key];
        }
      }
    }
  }

  return results;
}
